module.exports = __webpack_public_path__ + "img/cadastre-se.abeecfcf.png";